import { launchCameraAsync, launchImageLibraryAsync, MediaTypeOptions } from "expo-image-picker";

import { vibrateDevice } from "./CommonUtils";
import { getImageUrlMap } from "./oms/OMSCartUtils";
import { MoengageEvents, trackMoengageEvents } from "./webapp-services/MoengageUtils";
import { upsertCartImagesToRedux } from "./oms/UpsertCartData";

export const pickPrescriptionImageByCamera = async (props, { redirectRoute = '' }) => {
    let result: any = await launchCameraAsync({
        base64: true, quality: 0.1,
        allowsEditing: true, aspect: [4, 3],
        mediaTypes: MediaTypeOptions.Images
    })
    if (!result.cancelled) {
        vibrateDevice()
        let imageUrlMap = getImageUrlMap(result.uri, result.uri)
        upsertCartImagesToRedux(imageUrlMap);
        trackMoengageEvents(MoengageEvents.cart_created)
        if (redirectRoute) props.navigation.navigate(redirectRoute)
    }
}

export const pickPrescriptionImageByGallery = async (props, { redirectRoute = '' }) => {
    let result: any = await launchImageLibraryAsync({
        quality: 0, base64: true,
        allowsEditing: true, aspect: [4, 3],
        mediaTypes: MediaTypeOptions.Images
    });
    if (!result.cancelled) {
        vibrateDevice()
        let imageUrlMap = getImageUrlMap(result.uri, result.uri)
        upsertCartImagesToRedux(imageUrlMap);
        trackMoengageEvents(MoengageEvents.cart_created)
        if (redirectRoute) props.navigation.navigate(redirectRoute)
    }
}

export const pickMessageImageByCamera = async () => {
    var imageData
    let result: any = await launchImageLibraryAsync({
        quality: 0, base64: true,
        allowsEditing: true, aspect: [4, 3],
        mediaTypes: MediaTypeOptions.Images
    });
    if (!result.cancelled)
        imageData = result.uri
    return imageData
}

export const pickMessageImageByGallery = async () => {
    var imageData
    let result: any = await launchCameraAsync({
        quality: 0, base64: true,
        allowsEditing: true, aspect: [4, 3],
        mediaTypes: MediaTypeOptions.Images
    });
    if (!result.cancelled)
        imageData = result.uri
    return imageData
}